import FJCreationPanelFooter from '../view/FJCreationPanelFooter.jsx';
import FJUtil from '../../../../util/FJUtil.js';
import FJConstant from '../../../../constants/FJConstant.js';
import { useDispatch, useSelector } from 'react-redux';
import FJActionImageToImage from '../../../../redux/action/FJActionImageToImage.js';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import FJAppConstant from '../../../../constants/FJAppConstant.js';
import FJActionCommon from '../../../../redux/action/FJActionCommon.js';
import FJActionAIPhotoEditor from '../../../../redux/action/FJActionAIPhotoEditor.js';
import { useState } from 'react';
import FJRequirementsUtil from '../../../../util/FJRequirementsUtil.js';
import FJActionModal from '../../../../redux/action/FJActionModal.js';
import FJActionTextToImage from '../../../../redux/action/FJActionTextToImage.js';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';
import FJAIToolUtil from '../../../../util/FJAIToolUtil.js';

const FJCreationPanelFooterContainer = ({ appType }) => {
    useLocalStore();
    const dispatch = useDispatch();
    const historyList = useSelector(state => state.common.historyList);

    const taskStatus = useSelector(state => {
        if (appType === FJAppConstant.AI_PHOTO_EDITOR) {
            return state.aiPhotoEditor.taskStatus;
        } else if (appType === FJAppConstant.TEXT_TO_IMAGE) {
            return state.textToImage.taskStatus;
        } else if (appType === FJAppConstant.IMAGE_TO_IMAGE) {
            return state.imageToImage.taskStatus;
        } else {
            return state.common.taskStatus;
        }
    });

    const creationList = useSelector(state => {
        if (appType === FJAppConstant.AI_PHOTO_EDITOR) {
            return state.aiPhotoEditor.creationList;
        } else if (appType === FJAppConstant.TEXT_TO_IMAGE) {
            return state.textToImage.creationList;
        } else if (appType === FJAppConstant.IMAGE_TO_IMAGE) {
            return state.imageToImage.creationList;
        } else {
            return state.common.creationList;
        }
    });

    const [downloadEditImageLoading, setDownloadEditImageLoading] = useState(false);

    if (FJUtil.isGeneratingStatus(taskStatus) || taskStatus === FJConstant.ERROR || creationList.length === 0) {
        return null;
    }

    if (
        ![
            FJAppConstant.IMAGE_TO_IMAGE,
            FJAppConstant.AI_PHOTO_EDITOR,
            FJAppConstant.TEXT_TO_IMAGE,
            FJAppConstant.AI_VIDEO_GENERATOR,
        ].includes(appType)
    ) {
        return null;
    }

    const privacyStatus = creationList[0]?.privacyStatus;
    const shareKey = historyList.find(item => item.id === creationList[0]?.id)?.shareKey;
    const isShowPrivacyStatus = creationList.length === 1;
    const _onPrivacySettingChange = (value, callback) => {
        dispatch(
            FJActionCommon.multiPrivacySettingChangeAction(creationList, value, bool => {
                if (bool) {
                    dispatch(
                        FJActionCommon.dealCreationListAction(
                            creationList.map(item => {
                                return {
                                    ...item,
                                    privacyStatus: value,
                                };
                            }),
                            appType,
                        ),
                    );
                }
                callback(true);
            }),
        );
    };

    const _onDownload = () => {
        if (appType === FJAppConstant.IMAGE_TO_IMAGE) {
            setDownloadEditImageLoading(true);
            dispatch(FJActionImageToImage.downloadAllCreationAction(() => setDownloadEditImageLoading(false)));
        } else if (appType === FJAppConstant.AI_PHOTO_EDITOR) {
            setDownloadEditImageLoading(true);
            dispatch(FJActionAIPhotoEditor.downloadCreationAction(() => setDownloadEditImageLoading(false)));
        } else if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
            setDownloadEditImageLoading(true);
            FJRequirementsUtil.multiDownloadByUrls(
                [creationList[0].videoUrl],
                () => {
                    setDownloadEditImageLoading(false);
                },
                { isVideo: true },
            );
        }
    };

    const _imageToVideo = () => {
        if (appType === FJAppConstant.IMAGE_TO_IMAGE) {
            dispatch(FJActionImageToImage.animateImageAction());
        } else if (appType === FJAppConstant.TEXT_TO_IMAGE) {
            dispatch(FJActionTextToImage.imageToVideoAction());
        } else if (appType === FJAppConstant.AI_PHOTO_EDITOR) {
            dispatch(FJActionAIPhotoEditor.animateImageAction());
        } else if (appType === FJAppConstant.AI_VIDEO_GENERATOR) {
            dispatch(FJActionModal.addAsEditPageAction([creationList[0].id]));
        }
    };

    const _continueEdit = () => {
        if (appType === FJAppConstant.AI_PHOTO_EDITOR) {
            dispatch(FJActionAIPhotoEditor.continueEditAction());
        }
    };

    const _shareToSociety = type => {
        dispatch(FJActionModal.shareToSocietyAction(creationList[0]?.id, type));
    };
    const _addToMedia = () => {
        let list = creationList.map(item => item.imgUrl);
        if (FJAIToolUtil.getVideoAppTypeList().includes(appType)) list = creationList.map(item => item.videoUrl);
        else if (creationList[0].isAudioGenerator) list = creationList.map(item => item.audioUrl);
        dispatch(FJActionEditPage.addMultipleMediaToMediaLibraryAction(list, { from: 'generate' }));
    };

    return (
        <FJCreationPanelFooter
            isShowPrivacyStatus={isShowPrivacyStatus}
            privacyStatus={privacyStatus}
            onPrivacySettingChange={_onPrivacySettingChange}
            shareKey={shareKey}
            onDownload={_onDownload}
            isDownloading={downloadEditImageLoading}
            imageToVideo={_imageToVideo}
            appType={appType}
            continueEdit={_continueEdit}
            shareToSociety={_shareToSociety}
            onAddToMedia={_addToMedia}
        />
    );
};

export default FJCreationPanelFooterContainer;
